import { Availability, UserHomeFeedItem } from '@models/Availability'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { AVAILABILITY_VIEWERS_URL } from '@utils/urls'

const fetchAvailabilityForTier = (
  venueId: number,
  partySize: number,
  date: string,
  tiers: number[],
  diagnostic = false
) =>
  SBAPI.Fetch<Availability>(`${AVAILABILITY_VIEWERS_URL}/${venueId}`, {
    partySize: String(partySize),
    date,
    venue: String(venueId),
    tiers,
    ...(diagnostic ? { diagnostic: '1' } : {}),
  })

// Simulate the app home page for a specific user: every venue the user can see (membership /
// app_restriction gating) with availability computed as that user (real loyalty-tier filtering).
const fetchHomeFeedForUser = (userId: number, partySize: number, date: string) =>
  SBAPI.Fetch<UserHomeFeedItem[]>(`${AVAILABILITY_VIEWERS_URL}/user/${userId}`, {
    partySize: String(partySize),
    date,
  }).then((res) => res.data)

export { fetchAvailabilityForTier, fetchHomeFeedForUser }
